import React from 'react';
import styles from './list-icon.module.scss';

type Props = {
  icon: string,
  onClick?: () => void
};

const ListIcon: React.FC<Props> = ({ icon, onClick }) => {
  return (
    <span className={styles[icon]} onClick={onClick} />
  );
}

export default ListIcon;
